// extracted by mini-css-extract-plugin
module.exports = {"Card":"CircleProgress_Card__dfFgy","Percent":"CircleProgress_Percent__Xvw38","Number":"CircleProgress_Number__3RGKE"};